import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f37ac7c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "progress-track" }

import { computed } from 'vue';

/**
 * TYPES
 */
type Props = {
  width: string | number;
  size?: string;
  color?: string;
};

/**
 * PROPS
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'BalProgressBar',
  props: {
    width: null,
    size: { default: '1' },
    color: { default: 'emerald' }
  },
  setup(__props: any) {

const props = __props as { width: string | number, size: string, color: string };



/**
 * COMPUTED
 */
const barClasses = computed(() => ({
  [`h-${props.size}`]: true,
  [`bg-${props.color}-400`]: true,
}));

const barStyles = computed(() => ({
  width: `${props.width}%`,
}));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(['progress-bar', _unref(barClasses)]),
      style: _normalizeStyle(_unref(barStyles))
    }, null, 6)
  ]))
}
}

})